import { render, staticRenderFns } from "./PDropdownItem.vue?vue&type=template&id=33706330"
import script from "./PDropdownItem.vue?vue&type=script&lang=js"
export * from "./PDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports